mutation RepublishEventState($eventId: ID!) {
  result: StreamToolsRepublishEventState(eventId: $eventId) {
    republished
  }
}
